import React from 'react';
import { string, arrayOf, shape, func } from 'prop-types';
import { getThemeObj } from '@/helpers/index';
import { SSkillsList, SSkillsListItem } from './styles';

const SkillsList = ({ skills, handleSelect, handleSkillOver, handleSkillLeave, currentId }) => {

  const renderList = () => skills.map(skill => {
    const {id, name, theme } = skill;
    return (
      <SSkillsListItem
        key={id} isSelected={id === currentId}
        onClick={() => handleSelect(id, theme)}
        onMouseOver={() => handleSkillOver(id, theme)}
        onMouseLeave={handleSkillLeave}
        color={getThemeObj(theme).color}
      >
        {name}
      </SSkillsListItem>);

  });

  return (
    <SSkillsList>
      {renderList()}   
    </SSkillsList>
  );
};

SkillsList.propTypes = {
  skills: arrayOf(shape({
    id: string.isRequired,
    name: string.isRequired,
    theme: string.isRequired,
  })).isRequired,
  handleSelect: func.isRequired,
  currentId: string.isRequired,
  handleSkillOver: func.isRequired,
  handleSkillLeave: func.isRequired,
};

export default SkillsList;
